module.exports = __webpack_public_path__ + "static/media/discount.9546fe6c.svg";